import { Grid, Typography } from "@mui/material";
import DividerTitle from "components/utils/DividerTitle";
import InfoBulleSwitch from "components/utils/InfoBulles/InfoBulleSwitch";
import type { ReactNode } from "react";

type FormSectionTitleProps = {
  title: string;
  infoKey?: string;
};

function FormSectionTitle({ title, infoKey }: Readonly<FormSectionTitleProps>): ReactNode {
  return (
    <Grid container size={12} sx={{ alignItems: "center" }}>
      <Grid size="grow">
        <DividerTitle>
          <Typography variant="h5">{title}</Typography>
        </DividerTitle>
      </Grid>
      {infoKey != null && infoKey !== "" && (
        <Grid size="auto">
          <InfoBulleSwitch infoKey={infoKey} />
        </Grid>
      )}
    </Grid>
  );
}

export default FormSectionTitle;
